module.exports = __webpack_public_path__ + "img/playbutton21.529561da.png";